/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { status4B4EnumSchema } from "./status4B4EnumSchema.ts";

export const tableOrderInfoSchema = z
	.object({
		id: z.uuid(),
		number: z.int().nullable(),
		total_cost: z.number().nullish(),
		available_extend: z.boolean(),
		created_at: z.iso.datetime(),
		status: status4B4EnumSchema
			.optional()
			.describe(
				"* `created` - Создан локально\n* `waiting_payment` - Ожидает оплаты\n* `waiting_deferred_payment` - Ожидает отложенной оплаты\n* `partial_paid` - Частично оплачен\n* `paid` - Оплачен\n* `failed_payment` - Ошибка оплаты\n* `failed_after_paid` - Ошибка после оплаты\n* `waiting_creation_iiko` - Ожидает создания в iiko\n* `failed` - Ошибка\n* `sent` - Создан в iiko\n* `confirmed` - Подтвержден пользователем\n* `failed_after_sent` - Ошибка создания в iiko\n* `waiting_for_fiscalization` - Ожидает фискализации\n* `sent_fiscalization` - Отправлен на фискализацию\n* `failed_after_sent_fiscalization` - Ошибка после отправки на фискализацию\n* `fake_fiscalized` - Фейковая временная фискализация без явно отправки на фискализацию (для режимов PSN и DESTROYER)\n* `fiscalized` - Фискализирован, ожидает оплаты или отправки на инициализацию оплаты\n* `payment_initiation` - Инициирована оплата\n* `payment_initiation_retry` - Повторная инициация оплаты\n* `failed_after_payment_initiation` - Ошибка после инициации оплаты\n* `waiting_for_refund` - Ожидает возврата\n* `refunded` - Возвращен\n* `refund_failed` - Ошибка возврата\n* `waiting_manual_action` - Ожидает ручного действия персонала\n* `completed` - Заказ завершен\n* `cancelled` - Заказ отменен",
			),
	})
	.describe("Заказ стола, к которому гость может присоединиться.");
